import { Component, Input, OnInit } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Segmento } from '../../_models/segmento';
import { SegmentoProductosService } from '../../_services/segmento-productos.service';
import { ProductoService } from '../../_services/producto.service';
import { SegmentoProducto } from '../../_models/segmento-producto';
import { forkJoin, Observable } from 'rxjs';
import { Producto } from '../../_models/producto';

@Component( {
  templateUrl: 'segmento-productos.component.html',
  selector: 'app-segmento-productos',
  providers: [ ConfirmationService ]
} )
export class SegmentoProductosComponent implements OnInit {
  columnas: any[];
  formulario: FormGroup;
  carSegmentoProducto: boolean;
  segmentoProductos: SegmentoProducto[] = [];
  @Input()
  segmento: Segmento;
  submitted: boolean;
  guardando: boolean;
  productos: SelectItem[];
  allProductos: Producto[];

  constructor( private navServicio: NavService,
               private router: Router,
               private formBuilder: FormBuilder,
               private segmentoProductosService: SegmentoProductosService,
               private productosService: ProductoService,
               private confirmacionServicio: ConfirmationService ) {
  }


  ngOnInit(): void {
    this.formulario = this.formBuilder.group( {
      idProducto: [ null, [ Validators.required ] ],
      indicadorHabilitado: [ true ]
    } );
    this.columnas = [
      { field: 'producto', header: this.navServicio.buscarMensaje( 'SEGMENTOSPRODUCTOS.LBL_PRODUCTO' ), sort: true },
      { field: 'tipoProductoBancario', header: this.navServicio.buscarMensaje('PRODUCTO.LBL_TIPOPRODUCTO'), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'SEGMENTOSPRODUCTOS.LBL_ACCIONES' ), sort: true },
    ];
    forkJoin( this.productosService.listado(),
      this.segmentoProductosService.obtenerPorSegmento( this.segmento.idSegmento ) ).subscribe( ( [ res1, res2 ] ) => {
      this.allProductos = res1.sort(function (a, b) {
        return a.orden - b.orden;
      });
      this.segmentoProductos = res2;
      this.carDropdown();
    }, ( err1 ) => {
      this.navServicio.setMesage( 4, {
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo cargar la información. Intente nuevamente.'
      } );
    } );
  }

  carDropdown(): void {
    this.productos = [];
    this.allProductos.map( p => {
      if ( p.indicadorHabilitado && !this.segmentoProductos.find( sp => sp.indicadorHabilitado && sp.idProducto === p.idProducto ) ) {
        this.productos.push( { label: p.nombre, value: p.idProducto } );
      }
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  get segProductos() {
    return this.segmentoProductos.filter( s => s.indicadorHabilitado );
  }

  onSubmit(): void {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.carSegmentoProducto = true;
      const temp: SegmentoProducto = this.formulario.value;
      temp.idSegmento = this.segmento.idSegmento;
      temp.segmento = this.segmento.nombre;
      const producto: Producto = this.allProductos.find( p => p.idProducto === temp.idProducto );
      if(producto) {
        temp.producto = producto.nombre;
        temp.tipoProductoBancario = producto.tipoProductoBancario;
      }
      const a = this.segmentoProductos.find( sp => sp.idProducto === temp.idProducto );
      if ( a ) {
        temp.idSegmentoProducto = a.idSegmentoProducto;
      }
      temp.indicadorHabilitado = true;
      if ( temp.idSegmentoProducto ) {
        this.segmentoProductosService.actualizar( temp ).subscribe( res => {
          const tempSegmentoP: SegmentoProducto[] = this.segmentoProductos;
          this.segmentoProductos = [];
          tempSegmentoP.map( t => {
            if ( t.idSegmentoProducto === temp.idSegmentoProducto ) {
              t.indicadorHabilitado = true;
            }
          } );
          this.segmentoProductos = tempSegmentoP;
          this.carDropdown();
          this.formulario.reset();
          this.submitted = false;
          this.carSegmentoProducto = false;
        } );
      } else {
        this.segmentoProductosService.agregar( temp ).subscribe( res => {
          temp.idSegmentoProducto = res.idSegmentoProducto;
          this.segmentoProductos.push( temp );
          this.carDropdown();
          this.formulario.reset();
          this.submitted = false;
          this.carSegmentoProducto = false;
        } );
      }
    } else {
      return;
    }
  }

  disable( row: SegmentoProducto ): void {
    row.indicadorHabilitado = false;
    this.segmentoProductosService.actualizar( row ).subscribe( res => {
      const temp: SegmentoProducto[] = this.segmentoProductos;
      this.segmentoProductos = [];
      temp.map( t => {
        if ( t.idSegmentoProducto === row.idSegmentoProducto ) {
          t.indicadorHabilitado = false;
        }
      } );
      this.segmentoProductos = temp;
      this.carDropdown();
    } );
  }
}
